import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProxy } from 'src/app/core/store/user/user.proxy';
import { take } from 'rxjs';
import { USER_ROLES } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {
  returnUrl: string = '/';
  userRole$ = this.userProxy.currentRole$;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userProxy: UserProxy
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      this.returnUrl = params['returnUrl'] || '/';
    });
  }

  goBack(): void {
    this.goToDashboard();
  }

  goToDashboard(): void {
    this.userRole$.pipe(take(1)).subscribe(role => {
      if (role === USER_ROLES.hm || role === USER_ROLES.admin) {
        this.router.navigate(['/hm']);
      } else {
        this.router.navigate(['/']);
      }
    });
  }
}
